/**
 * PrimeVue Popover hides on any ancestor scroll. Clicking a clipped trigger
 * scrolls it into view on the next frame, so the popover opens and closes
 * itself. Leave the scroll-dismiss listener unbound for that reveal step.
 *
 * @param {object} options
 * @param {import('vue').Ref} options.popoverRef  ref to the PrimeVue Popover
 * @param {import('vue').Ref<boolean>} options.visibleRef
 * @returns {{ ignoreRevealScroll: () => void, cancelRevealScrollGuard: () => void }}
 */
export function usePopoverRevealScrollGuard({ popoverRef, visibleRef }) {
    let restoreFrame = 0;

    function cancelRevealScrollGuard() {
        cancelAnimationFrame(restoreFrame);
        restoreFrame = 0;
    }

    function restoreScrollListener() {
        restoreFrame = 0;

        if (!visibleRef.value) {
            return;
        }

        popoverRef.value?.bindScrollListener?.();
    }

    function ignoreRevealScroll() {
        const popover = popoverRef.value;

        if (!popover?.unbindScrollListener) {
            return;
        }

        popover.unbindScrollListener();
        cancelRevealScrollGuard();

        restoreFrame = requestAnimationFrame(() => {
            restoreFrame = requestAnimationFrame(restoreScrollListener);
        });
    }

    return { ignoreRevealScroll, cancelRevealScrollGuard };
}
